import React from 'react';
import { createRoot } from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import reportWebVitals from './reportWebVitals';
import App from './components/App';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <React.Fragment><App /></React.Fragment>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
